export function createPersonaContacto() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Apellidos: '',
    TipoPersonaContacto: '',
    EmpresaNombre: '',
    SocioNegocioClave: '',
    Cargo: '',
    Departamento: '',
    Email: '',
    EmailAlterno: '',
    Telefono: '',
    Celular: '',
    Direccion: '',
    Ciudad: '',
    Estado: '',
    PaisClave: '',
    CodigoPostal: '',
    ClaveErp: '',
    OrigenErp: '',
    FechaUltimaSync: null,
    Notas: '',
    EsActivo: true
  };
}

export const tiposPersonaContacto = [
  'Contratista',
  'Gobierno',
  'Estudiante',
  'Becario',
  'Residente',
  'Dueno',
  'Socio',
  'Consultor',
  'Proveedor externo',
  'Cliente externo',
  'Familiar',
  'Otro'
];
